<template>
  <div class="emotional-feedback">
    <div class="emotional-feedback__header">
      <span v-if="step !== 'success'" class="emotional-feedback__title">
        <SvgIcon
          class="emotional-feedback__title-star"
          icon="star-small"
          :size="26"
        />
        <span>{{ feedbackTitle }}</span>
      </span>
      <button
        v-if="step !== 'reaction'"
        title="Закрыть"
        class="emotional-feedback__close"
        @click="close"
      >
        <SvgIcon color="muted" icon="cross" size="14" />
      </button>
    </div>
    <WithSpinnerPlaceholder
      v-if="step !== 'success'"
      :loading="isLoading"
      :size="26"
    >
      <div class="emotional-feedback__content">
        <ReactionForm
          v-if="step === 'reaction'"
          v-model="reaction"
          class="emotional-feedback__reaction"
          @update:modelValue="sendEmotion"
        />
        <template v-else>
          <BasicTextarea
            v-model="message"
            class="emotional-feedback__textarea"
            name="message"
            appearance="feedback"
          />
          <BasicButton
            class="emotional-feedback__button"
            appearance="primary"
            size="l"
            :disabled="buttonDisabled"
            @click="sendForm"
          >
            Отправить
          </BasicButton>
        </template>
      </div>
    </WithSpinnerPlaceholder>
    <div v-else class="emotional-feedback__success">
      <img
        class="emotional-feedback__success-image"
        src="~images/feedback_received.svg"
        width="48"
        height="48"
      />
      <div class="emotional-feedback__success-info">
        <div class="emotional-feedback__success-title">Спасибо за отзыв!</div>
      </div>
    </div>
  </div>
</template>

<script>
import { handleRequestError } from 'src/services/api.js';
import { bem } from 'src/utils/bem.js';

import BasicButton from 'src/components/BasicButton/BasicButton.vue';
import BasicTextarea from 'src/components/form/BasicTextarea/BasicTextarea.vue';
import SvgIcon from 'src/components/icons/SvgIcon/SvgIcon.vue';
import WithSpinnerPlaceholder from 'src/components/placeholders/WithSpinnerPlaceholder/WithSpinnerPlaceholder.vue';
import ReactionForm from 'src/components/ReactionForm/ReactionForm.vue';

import { FeedbackService } from 'src/services/feedbacks';

export default {
  name: 'EmotionalFeedback',
  components: {
    SvgIcon,
    BasicTextarea,
    BasicButton,
    ReactionForm,
    WithSpinnerPlaceholder,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    feature: {
      type: String,
      default: '',
    },
  },
  emits: ['voted', 'close'],
  data() {
    return {
      isLoading: false,
      reaction: '',
      message: '',
      step: 'reaction', // 'feedback', 'success'
      feedBackId: null,
    };
  },
  mounted() {
    this.observer = new IntersectionObserver(
      ([e]) => {
        if (e.intersectionRatio === 1) {
          FeedbackService.trackViewFeedbackForm(this.feature);
        }
      },
      {
        threshold: 1.0,
      },
    );
    this.observer.observe(this.$el);
  },
  beforeDestroy() {
    this.observer.disconnect();
  },
  methods: {
    bem,
    async sendEmotion() {
      this.isLoading = true;

      try {
        const form = this.buildEmotionForm();
        const {
          data: { feedback },
        } = await FeedbackService.sendFeedback(form);
        this.feedBackId = feedback.id;
        this.step = 'feedback';
      } catch (error) {
        handleRequestError(error);
      } finally {
        this.isLoading = false;
      }
    },
    async sendForm() {
      this.isLoading = true;
      try {
        await FeedbackService.updateFeedback(this.feedBackId, {
          form: {
            message: this.message,
          },
        });
        this.step = 'success';
      } catch (error) {
        handleRequestError(error);
      } finally {
        this.isLoading = false;
      }
    },
    close() {
      this.$emit('close');
    },
    buildEmotionForm() {
      const { reaction, feature } = this;
      let action = window.location.pathname;

      if (window.location.search) action += window.location.search;

      const form = {
        reaction,
        feature,
        data: { action },
      };

      return { form };
    },
  },
  computed: {
    buttonDisabled() {
      return this.isLoading || !this.message.length;
    },
    feedbackTitle() {
      return this.step === 'reaction'
        ? this.title
        : 'Спасибо за оценку! Поделитесь своими впечатлениями';
    },
  },
};
</script>
